import {z} from "zod/v4-mini"

export type Distribution = "BECKMANN" | "GGX" | "ASHIKHMIN_SHIRLEY" | "MULTI_GGX"
export const distributionSchema = z.enum(["BECKMANN", "GGX", "ASHIKHMIN_SHIRLEY", "MULTI_GGX"])
